import { render, staticRenderFns } from "./IconCreditCard.vue?vue&type=template&id=5005fee9&"
import script from "./IconCreditCard.vue?vue&type=script&lang=ts&"
export * from "./IconCreditCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports